import React from 'react';
// components
import ContactUsComponent from '../contact-us/contact-us.component';
// services
import GATrackingService from '../../services/ga-tracking.service';
// images
const warningImg = require('../../images/status_warning.svg');
// styles
const styles = require('./bag-warning.scss');

interface IProps {
  userBookingRef: string;
  userEmail: string;
  language: string;
  multiLang: any;
}

interface IState {
  userBookingRef: string;
  userEmail: string;
  overlayClasses: string;
}

class BagWarningComponent extends React.Component<IProps, IState> {

  public gaService = null;

  constructor(props: any) {
    super(props);

    this.state = {
      userBookingRef: props.userBookingRef,
      userEmail: props.userEmail,
      overlayClasses: styles.overlay
    }
  }

  componentDidMount() {
    document.getElementsByTagName('body')[0].classList.add(styles.bodyFixed);
    this.gaService = new GATrackingService(
      'Questions',
      this.state.userBookingRef,
      'bags downgraded',
      null,
      null
    );
    this.gaService.sendPageView();
  }

  handleClick() {
    this.setState({ overlayClasses: styles.overlay + ' ' + styles.fadeOut });
    document.getElementsByTagName('body')[0].classList.remove(styles.bodyFixed);
  }

  public render() {
    const { language, multiLang } = this.props;

    return (
      <div className={this.state.overlayClasses}>
        <div className={styles.scrollContainer}>
          <button
            className={styles.btnClose}
            onClick={(e) => this.handleClick()}
          >
            {multiLang[`closeText${language}`]}
            <i className={styles.icon}>close</i>
          </button>

          <div className={styles.section}>
            <img src={warningImg} />
            <h2>{multiLang[`issueWithBagFoundText${language}`]}</h2>
            <p>{multiLang[`youMayNotAblwToCheckInText${language}`]}</p>
            <p>
              {multiLang[`pleaseText${language}`]}{' '}
              <a
                target='_blank'
                className={styles.link}
                href='https://support.airportr.com/hc/en-us/categories/14634087250449-Customer-Support'
              >
                {multiLang[`contactUs${language}`]}
              </a>
            </p>
            <ContactUsComponent
              language={language}
              multiLang={multiLang}
              userBookingRef={this.state.userBookingRef}
              userEmail={this.state.userEmail}
              CSlink='https://support.airportr.com/hc/en-us/categories/14634087250449-Customer-Support'
            ></ContactUsComponent>
          </div>
        </div>
      </div>
    );
  }
}

export default BagWarningComponent;



// WEBPACK FOOTER //
// ./src/components/bag-warning/bag-warning.component.tsx